import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/GLB_Oxxo_V4.glb";
import { gsap } from "gsap";

export class MapOxxoTeam2TopicOne extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	eliminateAnimation() {
		if (this.animation) {
			this.animation.kill();
		}
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.Cafetera_Krea = gltf.scene.getObjectByName("Cafetera_Krea", true);
			this.Cafetera_2 = gltf.scene.getObjectByName("Cafetera_2", true);
			this.Cafetera_1 = gltf.scene.getObjectByName("Cafetera_1", true);
			this.Cafetera_3 = gltf.scene.getObjectByName("Cafetera_3", true);

			this.Salchichas = gltf.scene.getObjectByName("Salchichas", true);
			this.Verduras = gltf.scene.getObjectByName("Verduras", true);

			//*act 2
			this.Fast_Food = gltf.scene.getObjectByName("Fast_Food", true);

			//* iluminacion
			this.Mostrador001 = gltf.scene.getObjectByName("Mostrador001", true);
			this.Piso = gltf.scene.getObjectByName("Piso", true);
			this.Techo = gltf.scene.getObjectByName("Techo", true);
			this.Paredes = gltf.scene.getObjectByName("Paredes", true);
			this.Refri_coca_1 = gltf.scene.getObjectByName("Refri_coca_1", true);
			this.Estructura001 = gltf.scene.getObjectByName("Estructura001", true);
			this.Yelox = gltf.scene.getObjectByName("Yelox", true);
			this.Helado = gltf.scene.getObjectByName("Helado", true);

			const newMaterialPiso = this.Piso.material.clone();
			newMaterialPiso.color.set(0xd6d6d6);
			newMaterialPiso.emissiveIntensity = 2;
			newMaterialPiso.emissive.set("#2E2E2E");
			this.Piso.material = newMaterialPiso;
			const newMaterialTecho = this.Techo.material.clone();
			newMaterialTecho.color.set(0xffffff);
			newMaterialTecho.emissiveIntensity = 2;
			newMaterialTecho.emissive.set("#595959");
			this.Techo.material = newMaterialTecho;
			const newMaterialHelado = this.Helado.material.clone();
			newMaterialHelado.color.set(0xd1d1d1);
			newMaterialHelado.emissiveIntensity = 3.6;
			newMaterialHelado.emissive.set("#5E5E5E");
			this.Helado.material = newMaterialHelado;

			this.Paredes.material.emissiveIntensity = 2;
			this.Refri_coca_1.material.emissiveIntensity = 0.98;
			this.Yelox.material.emissiveIntensity = 2.58;
			this.Estructura001.material.emissive.set("#595959");
			this.Estructura001.material.emissiveIntensity = 1;
			this.Mostrador001.material.emissive.set("#737373");
			this.Mostrador001.material.emissiveIntensity = 2;

			// gltf.scene.traverse((child) => {
			// 	// Verifica si el hijo tiene un material antes de aplicar la opacidad
			// 	if (child.material) {
			// 		// Establece la opacidad del material del hijo en 0.2
			// 		child.material.opacity = 0.2;
			// 		// Asegúrate de que el material tenga transparencia activada
			// 		child.material.transparent = true;
			// 	}
			// });
		});
	}

	onAnimate(object) {
		if (this.animation) {
			this.animation.kill();
		}

		if (!object) {
			return
		}
		const newMaterial = object.material.clone();
		object.material = newMaterial;

		this.Salchichas.material.emissiveIntensity = 1;
		this.Verduras.material.emissiveIntensity = 1;

		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	onAnimateTwo(object) {
		if (this.animation) {
			this.animation.kill();
			this.Cafetera_Krea.material.emissiveIntensity = 1;
			this.Cafetera_2.material.emissiveIntensity = 1;
			this.Cafetera_1.material.emissiveIntensity = 1;
			this.Cafetera_3.material.emissiveIntensity = 1;
			this.Yelox.material.emissiveIntensity = 1;
		}

		if (!object) {
			return
		}
		const newMaterial = object.material.clone();
		object.material = newMaterial;

		this.Cafetera_Krea.material.emissiveIntensity = 1;
		this.Cafetera_2.material.emissiveIntensity = 1;
		this.Cafetera_1.material.emissiveIntensity = 1;
		this.Cafetera_3.material.emissiveIntensity = 1;
		this.Yelox.material.emissiveIntensity = 1;


		this.animation = gsap.to(object.material, {
			emissiveIntensity: 15,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	renderAnimations() { }
}
